import React from 'react'
import Pdf from "react-to-pdf";
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import IconButton from '@material-ui/core/IconButton'
import styles from './barcodepdf.module.css'; 
import { Tooltip } from '@material-ui/core';
import Barcode  from 'react-barcode'; 
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    button: {
      margin: theme.spacing(1),
    },
  }));
const DownloadBarcode = (props) => {
    const ref = React.createRef(); 
    const classes = useStyles();
    let val = props.order.order_barcode;
    return ( 
        <React.Fragment>
            <Pdf targetRef={ref} filename={`order-PI-${val}.pdf`}>
                {({toPdf}) => (
                    <Tooltip title="Download Order Barcode">
                        <Button
                            onClick={toPdf}
                            variant="contained"
                            color="default"
                            className={classes.button}
                            startIcon={<GetAppRoundedIcon />}
                        >
                            Download Barcode
                        </Button>
                        {/* <IconButton onClick={toPdf}>
                            <GetAppRoundedIcon />
                        </IconButton> */}
                    </Tooltip>
                )}
            </Pdf>
            <div ref={ref} className={styles.container}>  
                <div className={styles.content}> 

                    {props.order &&
                    <React.Fragment>
                        <div className={styles.barcodeLg}>
                            <Barcode value={val} />
                            <p>Order Type: {props.order.orderType}</p>
                            <p>Order From: {props.order.orderFrom && props.order.orderFrom && props.order.orderFrom.name}</p>
                            <p>Order To:{props.order.orderType == "sales" ? <>{props.order.partner && props.order.partner.name}</> : <>{props.order.warehouse && props.order.warehouse.name}</>} </p>
                        </div>
                        
                    </React.Fragment>}
                </div>
            </div>
        </React.Fragment>
    )   
}

export default DownloadBarcode;
